import type { ReactElement, ReactNode } from "react";

import { TODAY_PAGE_NAV_LABEL, TODAY_PAGE_PATH } from "@/lib/navigation/todayPage";
import asrLogoChalk from "@assets/logo/ASR-Primary-Chalk.webp";

export interface ErrorPageBrandHeaderProps {
  children: ReactNode;
}

/** App header with the ASR wordmark when the full top bar cannot mount. */
export function ErrorPageBrandHeader({ children }: ErrorPageBrandHeaderProps): ReactElement {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background">
      <header className="sticky top-0 z-50 flex h-16 w-full items-center bg-sidebar px-4 shadow-[0_1px_3px_rgba(15,23,42,0.08)] lg:px-6">
        <a href={TODAY_PAGE_PATH} aria-label={`Go to ${TODAY_PAGE_NAV_LABEL}`}>
          <img
            src={asrLogoChalk}
            alt="A Safer Risk Logo"
            className="h-24 w-24 object-contain"
            width={307}
            height={96}
          />
        </a>
      </header>
      <main className="flex min-h-0 w-full flex-1 flex-col">{children}</main>
    </div>
  );
}
